import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as queryKeyProjectmelding } from '../hooks/useProjectmelding'
import { patchProjectmelding } from '../services/patchProjectmelding'

export { usePatchProjectmelding }

const usePatchProjectmelding = () => {
  const { successAlert, errorAlert } = useAlerts()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: patchProjectmelding,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyProjectmelding] })

      successAlert('Wijziging succesvol opgeslagen')
    },
    onError: (error: any) => {
      errorAlert('Fout bij opslaan wijziging', error)
    },
  })
}
